@if (!isLoading) {
  <div class="offer-page">
    @if (offer) {
      <app-offer
        [id]="'offer-' + offer.offerId"
        [offer]="offer"
        [baseurl]="baseurl"
        [user]="user$ | async"
        [index]="1"
        [total]="1"
        (offerAccepted)="onOfferAccepted($event)"
        >
      </app-offer>
    } @else {
      <div class="offer-empty">
        <!-- Debug: unavailableForLocation={{ unavailableForLocation }}, isInactive={{ isInactive }}, isLoading={{ isLoading }}, error={{ error }} -->
        {{
        isInactive
        ? (inactiveMessageKey | cxTranslate)
        : unavailableForLocation
        ? (unavailableMessageKey | cxTranslate)
        : ('myOffers.emptyState.notFound' | cxTranslate)
        }}
      </div>
    }
  </div>
} @else {
  @if (isLoading) {
    <div>Loading offer details…</div>
  }
  @if (!isLoading && error) {
    <div>{{ error }}</div>
  }
}


